import { ApiError, errorCode, errorMessage } from "./errors";
import { unwrap } from "./queries";

/**
 * Tira o payload do envelope `{ data }` da API.
 *
 * O envelope não carrega nada além do próprio payload nas rotas que usam
 * isto, então ele para aqui e quem consome recebe a lista/objeto direto.
 */
export async function payload<T>(
  request: Promise<{ data?: { data?: T } }>,
): Promise<T> {
  const body = await unwrap(request);
  if (body.data === undefined) {
    throw new ApiError("malformed_response", "A resposta veio sem `data`.");
  }
  return body.data;
}

/**
 * Variante do `payload` pras rotas onde "ainda não existe" é estado NORMAL,
 * não erro: Stripe nunca conectado, deposit-policy não configurada, depósito
 * ainda não gerado, telefone nunca visto. Nesses casos a API responde 404 com
 * ErrorEnvelope e a tela precisa de `null` pra renderizar "não configurado",
 * não de uma exceção.
 *
 * Precisa do `response` cru (o `unwrap` não carrega status HTTP), então
 * recebe o objeto completo do openapi-fetch em vez de passar pelo `unwrap`.
 */
export async function payloadOrNullOn404<T>(
  request: Promise<{ data?: { data?: T }; error?: unknown; response: Response }>,
): Promise<T | null> {
  const { data, error, response } = await request;
  if (response.status === 404) {
    return null;
  }
  if (error || data === undefined) {
    throw new ApiError(errorCode(error) ?? "unknown_error", errorMessage(error));
  }
  if (data.data === undefined) {
    throw new ApiError("malformed_response", "A resposta veio sem `data`.");
  }
  return data.data;
}
